import angular from 'angular';

(function() {
    'use strict';

    /**
     * Composant permettant de suivre l'evolution d'une tache asynchrone.
     *
     * Exemple: <kiss-long-task-progress task-id="10" title="vm.title" on-task-end="vm.onTaskEnd(results)" display="vm.display"></kiss-long-task-progress>
     *
     * @param display: si=true permet de declencher un nouveau check. IMPORTANT: une fois la callback onTaskEnd appelée, vous devez reinitialiser la
     * propriété display à false, pour pouvoir reenclencher un nouveau check.
     * @param taskId: l'identifiant de la tâche à suivre
     * @param title: titre de la fenêtre
     * @param interval: optionel. Intervalle de suivi en secondes. Si pas défini, il est fixé à 1sec
     * @param onTaskEnd: callback appelée en fin de suivi avec le resultat.
     */
    angular.module('app.widgets').component('kissLongTaskProgress', {
        bindings: {
            display: '<',
            taskId: '<',
            title: '<',
            interval: '<',
            onTaskEnd: '&'
        },
        controller: 'LongTaskProgressController as vm'
    });

    angular.module('app.widgets').controller('LongTaskProgressController', LongTaskProgressController);

    LongTaskProgressController.$inject = ['$uibModal'];

    function LongTaskProgressController($uibModal) {
        var vm = this;

        var checkInProgress = false;

        function executeNewCheck() {
            $uibModal
                .open({
                    templateUrl: require('./long-task-progress.html'),
                    controller: 'ModalLongTaskProgressCtrl as vm',
                    size: 'lg',
                    resolve: {
                        infos: function() {
                            //FIXME: verifier qu'on a bien toutes les infos avant d'ouvrir la modal
                            return { id: vm.taskId, title: vm.title, interval: (vm.interval ? vm.interval : 1) * 1000 };
                        }
                    },
                    backdrop: 'static',
                    keyboard: false
                })
                .result.then(closeModal);
            checkInProgress = true;
        }

        vm.$onChanges = function(changesObj) {
            if (changesObj.display && changesObj.display.currentValue && !checkInProgress) {
                executeNewCheck();
            }
        };

        function closeModal(results) {
            checkInProgress = false;
            vm.onTaskEnd({ results: results });
        }
    }

    angular.module('app.widgets').controller('ModalLongTaskProgressCtrl', ModalLongTaskProgressCtrl);

    ModalLongTaskProgressCtrl.$inject = ['$scope', '$timeout', '$interval', '$uibModalInstance', 'UtilsDA', 'infos'];

    function ModalLongTaskProgressCtrl($scope, $timeout, $interval, $uibModalInstance, UtilsDA, infos) {
        var vm = this;

        vm.longTaskDetails = null;
        vm.infos = infos;
        var isCallInProgress = false;

        var intervalProgressCheck = null;
        intervalProgressCheck = $interval(function() {
            //Ne pas relancer si une requete est en cours, afin d'eviter d'engorger le serveur.
            if (isCallInProgress) {
                return;
            }
            isCallInProgress = true;
            UtilsDA.getLongTaskDetails(vm.infos.id).then(
                function(details) {
                    isCallInProgress = false;
                    vm.longTaskDetails = details;
                    if (vm.longTaskDetails.endDate) {
                        $interval.cancel(intervalProgressCheck);
                        $timeout(function() {
                            $uibModalInstance.close(vm.longTaskDetails.result);
                        }, 2000);
                    }
                },
                function() {
                    //Erreur: ne rien faire, ça peut être un raté!
                }
            );
        }, vm.infos.interval);
    }
})();
